import BreadCrumb from "components/Common/BreadCrumb";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { Container } from "reactstrap";
import ListPool from "./ListPool";

export default function Pool() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = `${t("Home")} - ${t("Pool Management")}`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Pool Management")} pageTitle={t("Home")} />
          <ListPool />
          <ToastContainer autoClose={2000} limit={1} />
        </Container>
      </div>
    </React.Fragment>
  );
}
